export default __webpack_public_path__ + "static/media/medical.0889c4f6.png";